import React from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody, Button } from "reactstrap";
import Network from "~/services/networks";

const LimitedSurveyModal = ({isModalOpen, setModalOpen, item, showPointsLimit, showPaymentsLimit}) => {

  const closeModal = ()=> setModalOpen(false);

  return(
    <Modal isOpen={isModalOpen} toggle={closeModal} centered>
      <ModalHeader toggle={closeModal}> {item.name} </ModalHeader>

      <ModalBody>
      {showPaymentsLimit && <p>You must have at least <strong>{item.usersPaymentLimit}</strong> accepted cashouts to be able to complete <strong>{item.name}</strong> {item.type === Network.type.SURVEY ? "surveys" : "offers"}.</p> }
        {showPointsLimit && <p>You must have at least <strong>{item.limitPoints}</strong> points to be able to complete <strong>{item.name}</strong> {item.type === Network.type.SURVEY ? "surveys" : "offers"}.</p>}
      </ModalBody>

      <ModalFooter className="jc-center">
        <Button className="btn btn-danger pull-left" onClick={()=> setModalOpen(false)}> Cancel </Button>
      </ModalFooter>

    </Modal>
  );

}

export default LimitedSurveyModal;
